import { Component } from '@angular/core';
import { IconComponent } from 'src/app/ui-design-library/icon/icon.component';

@Component({
  selector: 'fnsr-thank-you',
  standalone: true,
  imports: [IconComponent],
  templateUrl: './thank-you.component.html',
})
export class ThankYouComponent {}
